// Library Import
import { createSlice } from "@reduxjs/toolkit";

// Local Imports
import {
  getToken,
  getChallenges,
  loginSignUp,
  deleteUser,
  createResetPassword,
  resetPassword,
} from "../thunks/userThunks.js";

const localUserDetails = JSON.parse(sessionStorage.getItem("localUserDetails"));

export const userSlice = createSlice({
  initialState: {
    loading: false,
    userDetails: localUserDetails
      ? { name: localUserDetails.name, email: localUserDetails.email }
      : null,
    error: null,
    userToken: localUserDetails
      ? { id: localUserDetails.id, token: localUserDetails.token }
      : null,
    userToast: { title: null, status: null },
  },
  name: "userSlice",
  reducers: {
    redUserSliceLoading: (state) => {
      return { ...state, loading: true };
    },
    redUserSliceNotLoding: (state) => {
      return { ...state, loading: false };
    },
    redSetUserDetails: (state, action) => {
      localStorage.setItem("localUserDetails", JSON.stringify(action.payload));
      return { ...state, userDetails: action.payload, loading: false };
    },
    redSetToast: (state, action) => {
      return { ...state, userToast: action.payload };
    },
    redSetToastReset: (state) => {
      return { ...state, userToast: { title: null, status: null } };
    },
    redSetLogout: (state) => {
      sessionStorage.removeItem("localUserDetails");
      return { ...state, userDetails: null, userToken: null };
    },

    redResetError: (state) => {
      return { ...state, error: null };
    },
    redResetDeletedUser: (state) => {
      return { ...state, deletedUser: null };
    },
    redResetPasswordEmail: (state) => {
      return { ...state, resetPasswordEmail: null };
    },
    redResetPasswordUpdated: (state) => {
      return { ...state, passwordUpdated: null };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getToken.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getToken.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          userToken: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          userToken: action.payload,
        };
      }
    });

    builder.addCase(getChallenges.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getChallenges.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          allChallenges: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          allChallenges: action.payload,
        };
      }
    });

    builder.addCase(deleteUser.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          deletedUser: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          deletedUser: true,
        };
      }
    });

    builder.addCase(loginSignUp.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(loginSignUp.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          userDetails: null,
          userLogin: false,
        };
      } else {
        sessionStorage.setItem(
          "localUserDetails",
          JSON.stringify(action.payload)
        );
        return {
          ...state,
          loading: false,
          error: null,
          userDetails: {
            name: action.payload.name,
            email: action.payload.email,
          },
          userLogin: true,
          userToken: {
            token: action.payload.token,
            id: action.payload.id,
          },
        };
      }
    });

    builder.addCase(createResetPassword.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(createResetPassword.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          resetPasswordEmail: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          resetPasswordEmail: true,
        };
      }
    });

    builder.addCase(resetPassword.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          passwordUpdated: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          passwordUpdated: true,
        };
      }
    });
  },
});

export const {
  redSetUserDetails,
  redUserSliceLoading,
  redUserSliceNotLoding,
  redSetToast,
  redSetToastReset,
  redSetLogout,
  redResetError,
  redResetDeletedUser,
  redResetPasswordEmail,
  redResetPasswordUpdated,
} = userSlice.actions;
